/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Recap_HInputs */

const en_funnel_ob_recap_h = /** @type {(inputs: Funnel_Ob_Recap_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're almost set to start listening everywhere.`)
};

const es_funnel_ob_recap_h = /** @type {(inputs: Funnel_Ob_Recap_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya casi puedes empezar a escuchar en todas partes.`)
};

/**
* | output |
* | --- |
* | "You're almost set to start listening everywhere." |
*
* @param {Funnel_Ob_Recap_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_recap_h = /** @type {((inputs?: Funnel_Ob_Recap_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Recap_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_recap_h(inputs)
	return en_funnel_ob_recap_h(inputs)
});